import { useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Clock, MapPin, Search, ShoppingCart, User, Wrench } from "lucide-react";
import { useShop } from "./ShopContext";
import { CartDrawer } from "./CartDrawer";

const ShopHeader = () => {
  const { cartCount, setCartOpen, customer, settings } = useShop();
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const submit = (e) => { e.preventDefault(); navigate(`/shop/products?search=${encodeURIComponent(q.trim())}`); };
  return (
    <header className="sticky top-0 z-40" data-testid="shop-header">
      <div className="bg-[#0F172A] px-4 py-1.5 text-center text-[11px] text-slate-300">
        <Clock className="mr-1 inline h-3 w-3" /> Collection hours: {settings.collection_hours || "Mon-Fri 07:30 - 17:00 | Sat 08:00 - 13:00"}
      </div>
      <div className="bg-[#1E293B] px-4 py-3">
        <div className="mx-auto flex max-w-7xl items-center gap-3">
          <Link to="/shop" className="flex shrink-0 items-center gap-2 text-white" data-testid="shop-logo">
            <span className="rounded-lg bg-[#D96B27] p-1.5"><Wrench className="h-5 w-5" /></span>
            <span className="hidden font-extrabold leading-tight sm:block" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>BOSVELD<br /><span className="text-xs font-semibold text-orange-300">Bou & Hardware</span></span>
          </Link>
          <form onSubmit={submit} className="flex flex-1 overflow-hidden rounded-full bg-white">
            <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search cement, taps, feed..." className="min-w-0 flex-1 px-4 py-2 text-sm outline-none" data-testid="shop-search-input" />
            <button type="submit" className="bg-[#D96B27] px-4 text-white hover:bg-[#C2591B]" data-testid="shop-search-btn"><Search className="h-4 w-4" /></button>
          </form>
          <Link to={customer ? "/shop/account" : "/shop/login"} className="flex items-center gap-1 text-sm text-white hover:text-orange-300" data-testid="shop-account-link">
            <User className="h-5 w-5" /><span className="hidden md:inline">{customer ? customer.name?.split(" ")[0] : "Sign in"}</span>
          </Link>
          <button type="button" onClick={() => setCartOpen(true)} className="relative text-white hover:text-orange-300" data-testid="shop-cart-btn">
            <ShoppingCart className="h-6 w-6" />
            {cartCount > 0 && <span className="absolute -right-2 -top-2 rounded-full bg-[#D96B27] px-1.5 text-[11px] font-bold" data-testid="shop-cart-count">{cartCount}</span>}
          </button>
        </div>
      </div>
    </header>
  );
};

const ShopFooter = () => (
  <footer className="mt-16 bg-[#0F172A] px-4 py-10 text-sm text-slate-400">
    <div className="mx-auto grid max-w-7xl gap-6 sm:grid-cols-3">
      <div><p className="mb-2 font-bold text-white">Bosveld Bou & Hardware</p><p>Order online, collect in store. Pay when you collect.</p></div>
      <div><p className="mb-2 font-bold text-white">Shop</p><Link to="/shop/products" className="block hover:text-white">All products</Link><Link to="/shop/account" className="block hover:text-white">My orders</Link></div>
      <div><p className="mb-2 flex items-center gap-1 font-bold text-white"><MapPin className="h-4 w-4" /> Collect in store</p><Link to="/site/contact" className="hover:text-white">Find us & contact</Link></div>
    </div>
  </footer>
);

export default function ShopLayout() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="shop-layout">
      <ShopHeader />
      <main className="mx-auto max-w-7xl px-4 py-6"><Outlet /></main>
      <ShopFooter />
      <CartDrawer />
    </div>
  );
}
